import { CommonAlertService } from './../../services/common-alert.service';
import { filter } from 'rxjs/operators';
import { MasterService } from './../../home/services/master.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgForm, Form } from '@angular/forms';

@Component({
  selector: 'app-warehouses-modal',
  templateUrl: './warehouses-modal.component.html',
  styleUrls: ['./warehouses-modal.component.scss']
})
export class WarehousesModalComponent implements OnInit {

  public locationsData: any;
  public locationValue: any;
  public editOb: any;
  public editData: any;
  public locationName: any;
  public locationId: any;
  successMsg: any;
  public model = {
    location_id: ''
  } ;
  public user = {
    name : '',
  };

    constructor(public dialogRef: MatDialogRef<WarehousesModalComponent>,
                public masterService: MasterService, @Inject(MAT_DIALOG_DATA) data, public commonAlertService: CommonAlertService) {
    if (data) {
      this.editOb = data.edit;
    }
  }

  ngOnInit() {
    this.masterService.getData('/Locations/get').subscribe(res => {
      // @ts-ignore
      this.locationsData = res.data;
    });

    if (this.editOb) {
      const id = this.editOb.editID;
      // tslint:disable-next-line:variable-name
      const enc_id = this.editOb.encryId;
      const locationType = 'Warehouses';
      this.masterService.getRecordById(id, enc_id, '/warehouses/formData').subscribe(res => {
        // @ts-ignore
        this.editData = res.data;
        if (this.editData.edit.location_id) {
          const editLocationId = this.editData.edit.location_id;
          this.locationName = this.editData.locations.filter(location => location.id === editLocationId);
          this.locationId = this.editData.edit.location_id;
          this.locationName = this.locationName[0].name;

        } else {
          this.locationName = '';
        }


      });
    }
  }

  submitForm(data) {

    if (this.editData) {
      this.locationId = this.locationId ? this.locationId : '';
      data.location_id = this.locationId;

      // tslint:disable-next-line:variable-name
      const form_data = Object.assign(data, { id: this.editOb.editID }, { enc_id: this.editOb.encryId });
      this.successMsg = 'Record Updated Successfully';
      this.masterService.addEditRecord(form_data, '/Warehouses/store').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showEdit({message: this.successMsg});
        }
      });

    } else {
      // tslint:disable-next-line:variable-name
      const form_data = Object.assign(data, { id: 0 }, { enc_id: '' });
      this.successMsg = 'Record Added Successfully';
      this.masterService.addEditRecord(form_data, '/Warehouses/store').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showSuccessMsg({message: this.successMsg});
        }
      });

    }


    this.close();
  }

  close() {
    this.dialogRef.close();
  }

}
